import {Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import {Question} from '../../../models/question.model';
import {Answer} from '../../../models/answer.model';
import {AppComponent} from "../../../app.component";
import {QstTypes} from "../../../enums/qst-types";

@Component({
  selector: 'app-dropzone-single',
  templateUrl: './dropzone-single.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./dropzone-single.component.less']
})
export class DropzoneSingleComponent implements OnInit {
  @Input() question!: Question;
  @Input() answers!: Answer[];
  @Input() additional_text!: string;
  @Input() disabled!: boolean;
  @Output() answerSelected = new EventEmitter<(number | null)[]>();
  selectedAnswers: (number | null)[] = [];
  global_texts: any = null;
  drop_zones: Answer[] = [];
  drop_zones_valides: number = 1;

  constructor(
    public app: AppComponent) {
  }

  ngOnInit(): void {
    //console.log("question", this.question);
    this.addObjDropzone(this.question, this.drop_zones);

    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      this.global_texts = texts;
      // console.log('this.global_texts => ', this.global_texts);
    });
  }

  addObjDropzone(qst: Question, drop_zones: Answer[]) {
    console.log("qst ==> ", qst)
    for (let i = 0; i < this.drop_zones_valides; i++) {
      drop_zones.push(new Answer(null, '', false, ''));
    }
  }

  deleteObjDropzone(drop_zones: Answer[], index: number) {
    drop_zones[index].id = null;
    drop_zones[index].label = '';
    drop_zones[index].selected = false;
    drop_zones[index].image = '';
    drop_zones[index].is_drag_over = false;
    this.onAnswerChange();
  }

  isDraggable(answer: Answer): string | null {
    // I want to check also that the answer is no already in the selectedAnswers
    return !this.disabled && !this.selectedAnswers.includes(answer.id) ? 'true' : null;
  }


  onAnswerChange(): void {
    // In selectedAnswers, we only keep the ids of the selected answers order by the order of drop_zones
    this.selectedAnswers = this.drop_zones.map((answer) => answer.id);

    // this.selectedAnswers = this.answers.filter((answer) => answer.selected).map((answer) => answer.id);
    console.log("this.selectedAnswers => ", this.selectedAnswers);
    this.answerSelected.emit(this.selectedAnswers);
  }

  protected readonly QstTypes = QstTypes;
}
